import PropTypes from 'prop-types';
import Header from '../header/header';
import Sidebar from '../sidebar';
import ErrorBoundary from './ErrorBoundary';
import { SidebarProvider, useSidebar } from './sidebarContext';

const SidebarOverlay = () => {
  const { isOpen, close } = useSidebar();
  if (!isOpen) return null;
  return (
    <div
      className="sidebar-overlay"
      onClick={close}
      onKeyDown={(e) => {
        if (e.key === 'Escape') close();
      }}
      role="button"
      tabIndex={-1}
      aria-label="Close navigation"
    />
  );
};

const Layout = (props) => {
  const { children, className } = props;
  return (
    <SidebarProvider>
      <Header />
      <Sidebar />
      <SidebarOverlay />
      <div className={`layout-content ${className}`}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    </SidebarProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Layout.defaultProps = {
  children: null,
  className: '',
};

export default Layout;
